import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import UserAuthContainer from './components/Containers/UserAuthContainer'
import ROUTES from './routesConfig'

const MerchantPrivilegesLayout = () => {
  const auth = UserAuthContainer.useContainer()
  const location = useLocation()

  if (!auth.isMerchant()) {
    return (
      <Navigate
        to={ROUTES.HOME}
        state={{ from: location, notice: 'not_authorized' }}
        replace
      />
    )
  }

  return <Outlet />
}

export default MerchantPrivilegesLayout
